import { render, staticRenderFns } from "./epic_token.vue.js?vue&type=template&id=7b01c3be&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./epic_token.vue?vue&type=template&id=7b01c3be&vue3"
import script from "./epic_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./epic_token.vue?vue&type=script&lang=js&vue3"
export * from "./epic_token.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./epic_token.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports